import React from 'react'
import * as Displays from 'support/displays'
import { useValue } from '@morningtrain/react-resources'

function VacationRequestDate () {
  const startAt = useValue('requested_start_at')
  const endAt = useValue('requested_end_at')

  if (startAt === endAt) {
    return (
      <Displays.Date name='requested_start_at' />
    )
  }

  return (
    <>
      <Displays.Date name='requested_start_at' /> - <Displays.Date name='requested_end_at' />
    </>
  )
}

export default VacationRequestDate
